import React from 'react';
import { CTAButton } from './CTAButton';
export function DreamSection() {
  return <section className="w-full py-20 px-4 border-t" style={{
    backgroundColor: '#0f172a',
    borderColor: '#334155'
  }} data-id="element-58">
      <div className="max-w-3xl mx-auto" data-id="element-59">
        <h2 className="text-3xl md:text-4xl font-bold leading-tight mb-10 text-center" style={{
        color: '#f1f5f9'
      }} data-id="element-60">
          El Resultado
        </h2>

        <div className="rounded-md p-8 border mb-12" style={{
        backgroundColor: '#1e293b',
        borderColor: '#334155'
      }} data-id="element-61">
          <div className="space-y-4 text-lg" style={{
          color: '#94a3b8'
        }} data-id="element-62">
            <p style={{
            color: '#f1f5f9'
          }} data-id="element-63">
              <strong data-id="element-64">Es un miércoles por la mañana en 2026.</strong>
            </p>
            <p data-id="element-65">Ninguna alarma sonó. Te despertaste cuando tu cuerpo quiso.</p>
            <p data-id="element-66">Te preparas tu café. Abres tu laptop.</p>
            <p style={{
            color: '#f1f5f9'
          }} data-id="element-67">
              Tienes dos proyectos hoy:
            </p>

            <div className="pl-4 border-l-4 space-y-2 my-4" style={{
            borderColor: '#f59e0b'
          }} data-id="element-68">
              <p style={{
              color: '#f1f5f9'
            }} data-id="element-69">
                Landing page para un gimnasio en Medellín —{' '}
                <strong style={{
                color: '#f59e0b'
              }} data-id="element-70">
                  $350.000
                </strong>
              </p>
              <p style={{
              color: '#f1f5f9'
            }} data-id="element-71">
                Landing page para una clínica dental en Bogotá —{' '}
                <strong style={{
                color: '#f59e0b'
              }} data-id="element-72">
                  $450.000
                </strong>
              </p>
            </div>

            <p data-id="element-73">
              Abres ChatGPT. Copias el prompt de la guía. En{' '}
              <strong style={{
              color: '#f1f5f9'
            }} data-id="element-74">
                30 segundos
              </strong>{' '}
              tienes un texto profesional.
            </p>
            <p data-id="element-75">
              Abres Magic Patterns. Pegas el texto. En{' '}
              <strong style={{
              color: '#f1f5f9'
            }} data-id="element-76">
                45 minutos
              </strong>{' '}
              tienes una página que parece que costó $3.000.000.
            </p>
            <p data-id="element-77">Envías el trabajo. El cliente responde:</p>

            <p className="text-xl italic pl-4 border-l-4 my-4" style={{
            color: '#f59e0b',
            borderColor: '#f59e0b'
          }} data-id="element-78">
              "Esto es exactamente lo que necesitábamos. Enviando el pago
              ahora."
            </p>

            <p style={{
            color: '#f1f5f9'
          }} data-id="element-79">
              <strong data-id="element-80">Son las 10:30 AM.</strong> Ganaste{' '}
              <strong style={{
              color: '#f59e0b'
            }} data-id="element-81">
                $800.000
              </strong>
              . Terminaste de trabajar. En menos de 2 horas.
            </p>
          </div>
        </div>

        <CTAButton text="QUIERO ESTA VIDA — ACCEDER A LA GUÍA LPM™ POR $49.999" subtitle="✅ Empieza este fin de semana · ✅ Plan día a día incluido · ✅ Sin riesgo" scrollTo="ebook-main" data-id="element-82" />
      </div>
    </section>;
}